
import { useNavigate, Navigate } from 'react-router-dom';
import { T, Lang, getDefaultLang } from '../common/js/i18n';
import { getUserState } from '../store/index';
import CenterMiddle from '../components/CenterMiddle';
import LangSwitch from "./fragment/LangSwitch";
import Login from "./Login";

export default function Welcome() {
    let userState = getUserState();
    const navigate = useNavigate();
    if (userState.logined) {
        return (
            <Navigate to="/dashboard" />
        );
    } else {
        let logoPath = __webpack_public_path__ + "logo.svg";
        let isNotZh = Lang.Zh !== getDefaultLang();
        return (
            <div style={{ position: "relative", width: "100%", height: "100%" }}>
                <CenterMiddle>
                    <div style={{ textAlign: "center" }}>
                        <img src={logoPath} alt="" />
                    </div>
                    <div style={{ textAlign: "center", marginTop: "1em" }}>
                        {T({ en: "A simple code generator that speeds up your business code development.", zh: "一个简单的代码生成器平台，加快你堆业务代码的速度。" })}
                    </div>
                    <Login onDone={() => {
                        navigate("/dashboard");
                    }} />
                </CenterMiddle>
                {
                    isNotZh && (
                        <div style={{ position: "absolute", top: "1em", right: "1em" }}>
                            <LangSwitch />
                        </div>
                    )
                }
            </div>
        );
    }
}
